module.exports = __webpack_public_path__ + "img/favorite.877dd84d.svg";